import * as WP from "../../../_modules/wp/index.js";
import {Car} from "../../../_modules/car/index.js";
import {News} from "../../../_modules/news/index.js";
import {INDEX, SINGLE} from "./query.js";
import * as config from "../../../_modules/config/index.js";
export async function index() {
  const data = await WP.fetch(this.fetch, config.SNOWPACK_PUBLIC_ENDPOINT, INDEX);
  if (data.isError()) {
    console.error(`message: ${data.message}, code: ${data.code}`);
    return {
      news: [],
      cars: []
    };
  }
  ;
  const news = data.unwrap().getOr(["news", "nodes"], []).map((d) => new WP.WPJson(d)).map((d) => News.fromWPJson(d));
  const salesCars = data.unwrap().getOr(["stocks", "nodes"], []).map((d) => new WP.WPJson(d)).map((d) => Car.fromWPJson(d));
  const soldCars = data.unwrap().getOr(["soldStocks", "nodes"], []).map((d) => new WP.WPJson(d)).map((d) => Car.fromWPJson(d));
  const cars = salesCars.concat(soldCars).slice(0, 4);
  return {
    news,
    cars
  };
}
export async function single({params}) {
  const id = parseInt(params.id);
  const data = await WP.fetch(this.fetch, config.SNOWPACK_PUBLIC_ENDPOINT, SINGLE(id));
  if (data.isError()) {
    console.error(`message: ${data.message}, code: ${data.code}`);
    return {
      newsItem: null,
      news: [],
      cars: []
    };
  }
  ;
  const newsItemRaw = data.unwrap().getOr(["newsItem"], {});
  const newsItem = News.fromWPJson(new WP.WPJson(newsItemRaw));
  const news = data.unwrap().getOr(["news", "nodes"], []).map((d) => new WP.WPJson(d)).map((d) => News.fromWPJson(d)).filter((d) => d.id !== id).slice(0, 4);
  const salesCars = data.unwrap().getOr(["stocks", "nodes"], []).map((d) => new WP.WPJson(d)).map((d) => Car.fromWPJson(d)).filter((d) => d.id !== id);
  const soldCars = data.unwrap().getOr(["soldStocks", "nodes"], []).map((d) => new WP.WPJson(d)).map((d) => Car.fromWPJson(d)).filter((d) => d.id !== id);
  const cars = salesCars.concat(soldCars).slice(0, 4);
  return {
    newsItem,
    news,
    cars
  };
}
//# sourceMappingURL=preload.js.map
